function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
import { fixDateToFormat } from './utils';
import Button from '../Button';
import Label from '../Label';
import Input from '../Input';
var propTypes = {
  className: PropTypes.string,

  /** Label for the input field */
  label: PropTypes.string,

  /** Error message for the input field */
  error: PropTypes.string,

  /** Set input field to disabled */
  disabled: PropTypes.bool,

  /** Set input field to required */
  required: PropTypes.bool,

  /** Description below the input field */
  description: PropTypes.string,

  /** Size (height) of the input controls (small: 32px, medium: 40px, large: 48px) */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  displayFormat: PropTypes.string,

  /** Callback function when date(s) change */
  onDateChange: PropTypes.func,

  /** Callback function when input(s) on focus */
  onInputFocus: PropTypes.func,

  /** Callback function when date icon is clicked */
  onIconClick: PropTypes.func,

  /** Placeholder for date input */
  placeholder: PropTypes.string,

  /** List of allowed date formats */
  customFormatList: PropTypes.array
};
var defaultProps = {
  size: 'small',
  date: '',
  customFormatList: []
};

var SingleDateInput = /*#__PURE__*/function (_Component) {
  _inherits(SingleDateInput, _Component);

  var _super = _createSuper(SingleDateInput);

  function SingleDateInput(props) {
    var _this;

    _classCallCheck(this, SingleDateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var date = _this.props.date;
      var isValidDate = date !== null;

      if (prevProps.date !== date && isValidDate) {
        _this.setState({
          date: date
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      var onInputFocus = _this.props.onInputFocus;

      _this.setState({
        isFocused: true
      });

      onInputFocus && onInputFocus({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (value) {
      _this.setState({
        date: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (value) {
      var _this$props = _this.props,
          displayFormat = _this$props.displayFormat,
          onDateChange = _this$props.onDateChange,
          customFormatList = _this$props.customFormatList;
      var date = fixDateToFormat(value, displayFormat, customFormatList);

      if (date !== null) {
        _this.setState({
          date: date
        });

        onDateChange && onDateChange({
          date: date
        });
      } else {
        _this.setState({
          date: ''
        });

        onDateChange(null);
      }

      _this.setState({
        isFocused: false
      });
    });

    _this.state = {
      date: props.date,
      isFocused: false
    };
    _this.dateRef = React.createRef();
    return _this;
  }

  _createClass(SingleDateInput, [{
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          description = _this$props2.description,
          disabled = _this$props2.disabled,
          required = _this$props2.required,
          error = _this$props2.error,
          label = _this$props2.label,
          size = _this$props2.size,
          onIconClick = _this$props2.onIconClick,
          placeholder = _this$props2.placeholder;
      var _this$state = this.state,
          date = _this$state.date,
          isFocused = _this$state.isFocused;
      var containerClass = cx((_cx = {
        'input-skin': !isFocused && !error,
        'display-flex': true,
        'justify-content-between': true,
        'align-items-center': true,
        'input-skin--focus': isFocused,
        'input-skin--error': error
      }, _defineProperty(_cx, "input--".concat(size), true), _defineProperty(_cx, 'input-skin--disabled', disabled), _cx), className);
      var inputClass = cx({
        'height-100p': true,
        'input-skin--noborder': true
      });
      var descClass = cx({
        input__info: true,
        'color-text': true,
        'opacity-50p': disabled,
        'cursor-not-allowed': disabled
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "display-flex justify-content-between"
      }, label && /*#__PURE__*/React.createElement(Label, {
        text: label,
        className: "marginbottom-sm"
      }), required ? /*#__PURE__*/React.createElement("span", {
        className: "color-text--lightgrey font-sm"
      }, "Required") : null), /*#__PURE__*/React.createElement("div", {
        className: containerClass
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        onBlur: function onBlur(e) {
          return _this2.onBlur(e.target.value);
        },
        onChange: function onChange(e) {
          return _this2.handleInputChange(e.target.value);
        },
        onFocus: this.onFocus,
        value: date,
        placeholder: placeholder,
        className: inputClass,
        style: {
          width: '100px'
        },
        "aria-label": label,
        ref: this.dateRef,
        disabled: disabled,
        "aria-required": required
      })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
        className: "datepicker__inputicon",
        icon: "only",
        iconName: "calendar_date",
        "aria-label": "Interact with the calendar",
        size: size,
        kind: "borderless",
        onClick: function onClick() {
          return onIconClick({
            focused: true
          });
        },
        disabled: disabled
      }))), /*#__PURE__*/React.createElement("div", {
        className: "position-absolute"
      }, error && /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: "input__info color-text--error"
      }, error), description && !error && /*#__PURE__*/React.createElement("div", {
        className: descClass
      }, description)));
    }
  }]);

  return SingleDateInput;
}(Component);

SingleDateInput.propTypes = propTypes;
SingleDateInput.defaultProps = defaultProps;
SingleDateInput.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "componentDidUpdate",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "prevProps",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleInputChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SingleDateInput",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Size (height) of the input controls (small: 32px, medium: 40px, large: 48px)"
    },
    "date": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "customFormatList": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "List of allowed date formats"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for the input field"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Error message for the input field"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set input field to disabled"
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set input field to required"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Description below the input field"
    },
    "displayFormat": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onDateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function when date(s) change"
    },
    "onInputFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function when input(s) on focus"
    },
    "onIconClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function when date icon is clicked"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder for date input"
    }
  }
};
export default SingleDateInput;